import { queryOptions } from '@tanstack/react-query';
import { apiList } from '@/lib/api-client';
import { TEAM_ERROR_LABELS, type Group } from '@erp/shared';

export function groupsListOptions() {
  return queryOptions({
    queryKey: ['erp', 'groups', 'list'] as const,
    queryFn: async ({ signal }) => {
      const res = await apiList<Group>('/groups', { signal });
      if (res.error) throw res.error;
      return res.data.items;
    },
  });
}

/** Grupos vinculados à mesa (vazio = mesa visível a todos). */
export function deskGroupsOptions(deskId: number) {
  return queryOptions({
    queryKey: ['erp', 'desks', 'groups', { deskId }] as const,
    queryFn: async ({ signal }) => {
      const res = await apiList<Group>(`/desks/${deskId}/groups`, { signal });
      if (res.error) throw res.error;
      return res.data.items;
    },
  });
}

/** Códigos de erro da API com mensagem amigável em pt-BR. */
const ERROR_LABELS: Record<string, string> = {
  ...TEAM_ERROR_LABELS,
  group_in_use: 'Este grupo está vinculado a uma ou mais mesas — desvincule antes de excluir.',
  group_name_taken: 'Já existe um grupo com esse nome.',
  // spec 061: o que a sincronização com o TiFlux desfaria
  tiflux_managed_members:
    'Quem vem do TiFlux entra e sai deste grupo pelo grupo técnico de lá — mude pelo TiFlux.',
  tiflux_group_name: 'O nome deste grupo vem do TiFlux — mude pelo TiFlux.',
};

export function errorMessage(err: unknown): string {
  if (
    err !== null &&
    typeof err === 'object' &&
    'error' in err &&
    typeof (err as { error: unknown }).error === 'string'
  ) {
    const code = (err as { error: string }).error;
    return ERROR_LABELS[code] ?? code;
  }
  return err instanceof Error ? err.message : 'Erro inesperado';
}
